'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visitorErrorMiddleware = undefined;

var _getError = require('conversations-internal-schema/action/operators/getError');

var _isErrorAction = require('conversations-internal-schema/action/operators/isErrorAction');

var _actionToSentryFingerprint = require('conversations-internal-schema/action/operators/actionToSentryFingerprint');

var _getExtraErrorData = require('conversations-internal-schema/action/operators/getExtraErrorData');

var visitorErrorMiddleware = exports.visitorErrorMiddleware = function visitorErrorMiddleware() {
  return function (next) {
    return function (action) {
      window.Raven.captureBreadcrumb({
        message: action.type,
        category: 'redux action'
      });

      if ((0, _isErrorAction.isErrorAction)(action)) {
        var error = (0, _getError.getError)(action) || new Error(action.type);
        var extraData = (0, _getExtraErrorData.getExtraErrorData)(action);

        window.Raven.captureException(error, {
          fingerprint: (0, _actionToSentryFingerprint.actionToSentryFingerprint)(action),
          extra: { error: extraData }
        });

        var eventId = window.Raven.lastEventId();

        console.error('Failed Action:', action.type, 'EventId:', eventId);
        if (extraData) {
          Object.keys(extraData).forEach(function (key) {
            if (extraData[key]) {
              console.error('Extra Data [' + key + ']: ', extraData[key]);
            }
          });
        }
        console.error(error);
      }

      return next(action);
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/error-reporting/middleware/visitorErrorMiddleware.js
// module id = 851
// module chunks = 2 3